import { observer } from 'mobx-react-lite'
import { OCRConfirmBulkRerunDialog } from '@/features/jobs/scoping/components/OCRConfirmBulkRerunDialog'
import { type OCRConfirmBulkRerunDialogViewModel } from './OCRConfirmBulkRerunDialogViewModel'

export interface OCRConfirmBulkRerunDialogContainerProps {
  vm: OCRConfirmBulkRerunDialogViewModel
}

export const OCRConfirmBulkRerunDialogContainer = observer(
  function OCRConfirmBulkRerunDialogContainer({
    vm,
  }: OCRConfirmBulkRerunDialogContainerProps) {
    return (
      <OCRConfirmBulkRerunDialog
        showing={vm.modal.showing}
        selectedCount={vm.selectedCount}
        onClose={vm.cancel}
        onConfirm={vm.confirm}
      />
    )
  },
)
